import React from 'react';

import { FormHelperText } from '@mui/material';
import PropTypes from 'prop-types';

import { getHelperTextStyles } from './HelperText.styles';

const HelperText = ({ children, error = false }) => (
  <FormHelperText
    data-truncated
    className="helper-text truncate"
    component="span"
    sx={getHelperTextStyles({ error })}
  >
    {children}
  </FormHelperText>
);

HelperText.propTypes = {
  children: PropTypes.string.isRequired,
  error: PropTypes.bool,
};

export default HelperText;
